export const HANDLE_ERROR_ACTION = 'ERROR/HANDLE_ERROR';
